var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShippingbox({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "8.7656 -78.5879 79.7832 87.4004",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5273-10.5469L45.3125 6.49414C47.6074 7.8125 49.707 7.8125 51.9531 6.49414L81.7383-10.5469C85.4492-12.6465 87.5488-14.7461 87.5488-20.8496L87.5488-50.3418C87.5488-54.7852 85.9375-57.5684 82.3242-59.668L56.2012-74.6582C51.0742-77.5879 46.2402-77.5879 41.1133-74.6582L14.9902-59.668C11.3281-57.5684 9.76562-54.7852 9.76562-50.3418L9.76562-20.8496C9.76562-14.7461 11.8652-12.6465 15.5273-10.5469ZM19.2871-16.3574C17.1875-17.5781 16.3574-18.8965 16.3574-21.0449L16.3574-48.9746L45.2148-32.2754L45.2148-1.41602ZM78.0273-16.3574L52.0996-1.41602L52.0996-32.2754L80.957-48.9746L80.957-21.0449C80.957-18.8965 80.0781-17.5781 78.0273-16.3574ZM48.6328-38.3789L20.2148-54.6387L31.0547-60.9375L59.4238-44.5801ZM66.4551-48.584L37.8906-64.8438L43.8477-68.2617C47.168-70.166 50.1465-70.2148 53.418-68.2617L77.0996-54.6387Z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShippingbox);
export default __webpack_public_path__ + "static/media/shippingbox.395d7fe122e33d9fae1c81dec86cee54.svg";
export { ForwardRef as ReactComponent };